import type { UrlLocation } from '@seek/chalice-types';
import { Text } from 'braid-design-system';
import { useCallback, type ReactNode } from 'react';

import { TextLink } from 'src/components/NavLink/NavLink';
import { useDispatch } from 'src/store/react';
import {
  showPoeaCountryPickerFromNavigation,
  updateSearchSource,
} from 'src/store/search';
import type { TypedDispatch } from 'src/store/types';

export interface QuickSearchLinkProps {
  children?: string | ReactNode;
  linkProps: {
    ['aria-label']?: string;
    ['data-automation']?: string;
    analytics?: string;
    location: UrlLocation | string;
    rel?: string;
  };
}

const handlePoeaSpecificLinkClick = (
  dispatch: TypedDispatch,
  children?: string | ReactNode,
) => {
  const poeaKeywords = ['Work Abroad Jobs', 'POEA Jobs'];
  if (typeof children === 'string' && poeaKeywords.includes(children)) {
    return dispatch(showPoeaCountryPickerFromNavigation(true));
  }
};

const handleQuickSearchLinkClick = (
  dispatch: TypedDispatch,
  children?: string | ReactNode,
) => {
  // Dispatch the search source update for quick search links
  dispatch(updateSearchSource('QUICK'));

  // Handle POEA-specific logic
  handlePoeaSpecificLinkClick(dispatch, children);
};

export const QuickSearchLink = ({
  children,
  linkProps,
}: QuickSearchLinkProps) => {
  const dispatch = useDispatch();

  const handleClick = useCallback(() => {
    handleQuickSearchLinkClick(dispatch, children);
  }, [dispatch, children]);

  return (
    <Text size="small" tone="secondary" component="li">
      <TextLink weight="weak" {...linkProps} onClick={handleClick}>
        {children}
      </TextLink>
    </Text>
  );
};
